export const DISPLAY_TYPE = {
  playlist_list: "playlist-list",
  playlist_series: "playlist-series",
  branch: "branch",
};

export const PLAY_TYPE = {
  track: "track",
  playlist: "playlist",
};

export const DISPLAY_STYLE = {
  circle: "circle",
  square: "square",
  vertical: "vertical",
  rectangle: "rectangular",
};
